<template>
  <d-container fluid class="main-content-container p-4">
    <d-modal v-if="modalVisible" size="lg" @close="onModalClose">
      <d-modal-header>
        <d-modal-title>Détails de la transaction</d-modal-title>
      </d-modal-header>
      <d-modal-body>
        <d-form-row>
          <d-col class="pr-3 border-right">
            <div class="text-center mb-3">
              <b-image class="mb-1 logo" :src="operator_logo" thumbnail/>
              <br/>
              <d-badge outline pill :theme="badge">{{ transaction_status_fr }}</d-badge>
            </div>
            <c-input :disabled="!is_editable" container-class="mb-0" type="select"
                     label="Changer le statut de la transaction ?" :options="transaction_status_options"
                     v-model="transaction_status" :state="transaction_status_state">
              <template slot="first">
                <option :value="null">Sélectionnez un statut</option>
              </template>
              Veuillez sélectionner un statut
            </c-input>
            <d-form-checkbox v-if="transaction_status" v-model="update_balance" class="mt-1">
              Mettre à jour les soldes
            </d-form-checkbox>
            <c-input container-class="mb-3 mt-3" label="Opération" :value="operation_type" disabled/>
            <c-input container-class="mb-3" label="Référence de transaction" :value="transaction_ref" disabled/>
            <c-input container-class="mb-3" label="Référence courte" :value="short_ref" disabled/>
            <c-input container-class="mb-3" label="Référence chez l'opérateur" :value="operator_transaction_ref"
                     disabled/>
            <c-input type="textarea" container-class="mb-3" label="Motif" :value="transaction_reason" disabled/>
            <c-input type="textarea" container-class="mb-3" label="Message" :value="transaction_message" disabled/>
            <c-input type="datetime" container-class="mb-3" label="Initiée le" :value="created_at" disabled/>
            <c-input type="datetime" container-class="mb-3" label="Dernière modification" :value="updated_at" disabled/>
          </d-col>
          <d-col class="ml-2">
            <c-input container-class="mb-3" label="No de téléphone" :value="transaction_phone_number" disabled/>
            <c-input type="price" :currency="transaction_currency" container-class="mb-3" label="Montant"
                     :value="transaction_amount_raw" disabled/>
            <c-input type="price" :currency="transaction_currency" container-class="mb-3" label="Montant net"
                     :value="transaction_amount_net" disabled/>
            <c-input type="price" currency="XAF" container-class="mb-3" label="Montant en XAF"
                     :value="transaction_amount" disabled/>
            <c-input type="price" currency="XAF" container-class="mb-3" label="Commissions"
                     :value="transaction_commission" disabled/>
            <c-input type="price" currency="XAF" container-class="mb-3" label="Frais en XAF" :value="transaction_fees"
                     disabled/>
            <c-input type="price" currency="XAF" container-class="mb-3" label="Gain" :value="transaction_income"
                     disabled/>
            <c-input type="price" currency="XAF" container-class="mb-3" label="Payeur - Commissions"
                     :value="payer_commissions"
                     disabled/>
            <c-input type="price" currency="XAF" container-class="mb-3" label="Payeur - frais" :value="payer_fees"
                     disabled/>
            <c-input type="textarea" container-class="mb-3" label="Logs" :rows="3" :value="gateway_messages" disabled/>
          </d-col>
        </d-form-row>
        <c-table class="px-0 mt-3" :table-data="extraData" :fields="extraDataFields" :per-page="5">
          <p class="text-center" slot="empty">Aucune donnée supplémentaire.</p>
        </c-table>
      </d-modal-body>
      <d-modal-footer class="justify-content-center">
        <c-button-spinner v-if="is_editable" class="mr-2" variant="danger" :fetching="fetchingFormSubmit"
                          @click="onFormSubmit">
          <template slot="icon">
            <i class="fa fa-exclamation-triangle"></i>
          </template>
          Changer le statut
        </c-button-spinner>
        <c-button-spinner v-if="can_check_status" variant="success" :fetching="fetchingCheckStatus"
                          @click="onCheckStatus">
          <template slot="icon">
            <i class="fa fa-info-circle"></i>
          </template>
          Check le statut
        </c-button-spinner>
        <c-button-spinner v-if="can_sync_status" class="ml-2" variant="primary" :fetching="fetchingSyncStatus"
                          @click="onSyncStatus">
          <template slot="icon">
            <i class="fa fa-sync-alt"></i>
          </template>
          Sync. le statut
        </c-button-spinner>
        <c-button-spinner v-if="can_trigger_callback" class="ml-2" variant="warning"
                          :fetching="fetchingTriggerCallback" @click="onTriggerCallback">
          <template slot="icon">
            <i class="fa fa-arrow-up"></i>
          </template>
          Callback
        </c-button-spinner>
        <b-button variant="secondary" class="ml-2" @click="onModalClose">
          <i class="fa fa-times"></i>
        </b-button>
      </d-modal-footer>
    </d-modal>

    <div>
      <!-- COLLAPSE-->
      <b-button v-b-toggle.collapsible-search-form class="m-1 greenbutton">
        <i class="fa fa-filter mr-2 "></i> Recherche avancée
      </b-button>

      <!-- Element to collapse -->
      <b-collapse id="collapsible-search-form" class="mb-4">
        <d-card class="card-small">
          <d-card-body class="px-4 pb-0">
            <b-row>
              <d-input-group class="justify-content-center">
                <c-input label="Du" type="date" class="mr-3" v-model="startDate"/>
                <c-input label="Au" type="date" class="mr-3" v-model="endDate"/>
                <c-input label="Mot clé de recherche" placeholder="Rechercher par référence..."
                         v-model="search"/>
              </d-input-group>
            </b-row>
            <b-row>
              <d-input-group class="justify-content-center">
                <c-input type="select" label="Rechercher par statut" class="mr-2" :options="transaction_status_options"
                         v-model="searchStatus">
                  <template slot="first">
                    <option :value="null">-- Tous les statuts --</option>
                  </template>
                </c-input>
                <c-input type="select" label="Rechercher par opérateur" :options="operators"
                         v-model="operator">
                  <template slot="first">
                    <option :value="null">-- Tous les opérateurs --</option>
                  </template>
                </c-input>
              </d-input-group>
            </b-row>
            <b-row class="justify-content-center">
              <c-button-spinner class="inline-btn ml-1 mb-3" variant="primary" :fetching="fetchingSearch"
                                @click="onSearchSubmit">
                <template slot="icon">
                  <i class="fa fa-search"></i>
                </template>
                Rechercher
              </c-button-spinner>
            </b-row>
          </d-card-body>
        </d-card>
      </b-collapse>
    </div>

    <d-card class="card-small">
      <d-card-header class="px-4 pb-0">
        <d-input-group class="justify-content-center">
          <!--          <c-input type="select" class="mr-5" v-if="showGroupFilter" :options="transactionGroupOptions"-->
          <!--                   v-model="transactionGroup"/>-->
          <!--c-input class="w-25" placeholder="Rechercher par référence..." v-model="search"/>
          <c-button-spinner class="inline-btn ml-1" variant="primary" :fetching="fetchingSearch"
                            @click="onSearchSubmit">
            <template slot="icon">
              <i class="fa fa-search"></i>
            </template>
            Rechercher
          </c-button-spinner-->
        </d-input-group>
      </d-card-header>
      <d-card-body class="pt-0">
        <c-table :fetching="fetchingData" :table-data="filteredData" :fields="fields" :actions="actions" :per-page="50">
          <p class="text-center" slot="empty">Aucune transaction trouvée.</p>
        </c-table>
      </d-card-body>
    </d-card>
  </d-container>
</template>

<script>
import { Api, asset, formatAmount, Toast, truncate } from "@/helpers"

export default {
  title: "Transactions",
  data() {
    return {
      transactionGroupOptions: [
        {
          value: "",
          text: "Toutes les transactions",
        },
        {
          value: "USER",
          text: "Transactions des utilisateurs",
        },
        {
          value: "RAISING",
          text: "Transactions des cagnottes",
        },
        {
          value: "SERVICE",
          text: "Transactions des services",
        },
      ],
      transactionGroup: "SERVICE",
      search: "",
      searchData: {},
      fetchingSearch: false,

      fetchingData: false,
      data: [],

      //table header
      fields: [
        {
          key: "logo",
          label: "Opérateur",
          sortable: true,
        },
        {
          key: "operation_type",
          label: "Opération",
          sortable: true,
        },
        {
          key: "transaction_ref_pretty",
          label: "Référence",
          sortable: true,
        },
        {
          key: "transaction_phone_number_pretty",
          label: "Téléphone",
          sortable: true,
        },
        {
          key: "transaction_amount_pretty",
          label: "Montant",
          sortable: true,
        },
        {
          key: "transaction_income_pretty",
          label: "Gain",
          sortable: true,
        },
        {
          key: "created_at_pretty",
          label: "Initiée le",
          sortable: true,
        },
        {
          key: "status",
          label: "Statut",
          sortable: true,
        },
        {
          key: "actions",
          label: "Actions",
        },
      ],

      extraDataFields: [
        {
          key: "key",
          label: "Propriété",
        },
        {
          key: "value",
          label: "Valeur",
        },
      ],

      actions: [
        {
          type: "white",
          icon: "fa fa-ellipsis-h",
          title: "Détails de la transaction",
          handler: this.onItemSelect,
        },
      ],

      modalVisible: false,

      selectedItem: null,

      update_balance: true,
      transaction_status: null,
      transaction_status_options: [],

      submitted: false,
      fetchingFormSubmit: false,
      fetchingCheckStatus: false,
      fetchingSyncStatus: false,
      fetchingTriggerCallback: false,

      startDate: "",
      endDate: "",
      searchStatus: null,
      showGroupFilter: false,

      operators: [],
      operator: null,
    }
  },
  computed: {
    filteredData() {
      const search = this.search.toLowerCase()
      return this.data.filter(item => {
        return item.transaction_type.includes(this.transactionGroup) &&
          (!this.searchStatus || this.statusMatch(item.transaction_status, this.searchStatus)) && (
            (item.transaction_ref && item.transaction_ref.toLowerCase()
              .includes(search))
            || (item.short_ref && item.short_ref.toLowerCase()
              .includes(search))
            || (item.operator_transaction_ref && item.operator_transaction_ref.toLowerCase()
              .includes(search))
            || (item.transaction_phone_number && item.transaction_phone_number.toLowerCase()
              .includes(search))
            || (item.transaction_status_fr && item.transaction_status_fr.toLowerCase()
              .includes(search))
            || (item.transaction_reason && item.transaction_reason.toLowerCase()
              .includes(search))
            || (item.transaction_message && item.transaction_message.toLowerCase()
              .includes(search))
          )
      })
    },
    itemSelected() {
      return !!this.selectedItem
    },
    is_editable() {
      return this.auth.isOpManager()
    },
    operator_logo() {
      return this.itemSelected && this.selectedItem.operator ? asset(this.selectedItem.operator.logo) : ""
    },
    transaction_status_fr() {
      return this.itemSelected ? this.selectedItem.transaction_status_fr : ""
    },
    badge() {
      return this.itemSelected ? this.selectedItem.badge : ""
    },
    operation_type() {
      return this.itemSelected ? this.selectedItem.operation_type : ""
    },
    transaction_ref() {
      return this.itemSelected ? this.selectedItem.transaction_ref : ""
    },
    short_ref() {
      return this.itemSelected ? this.selectedItem.short_ref || "N/A" : ""
    },
    operator_transaction_ref() {
      return this.itemSelected ? this.selectedItem.operator_transaction_ref || "N/A" : ""
    },
    transaction_phone_number() {
      return this.itemSelected ? this.selectedItem.transaction_phone_number ? formatAmount(this.selectedItem.transaction_phone_number) : "---" : ""
    },
    created_at() {
      return this.itemSelected ? this.selectedItem.created_at : ""
    },
    updated_at() {
      return this.itemSelected ? this.selectedItem.updated_at : ""
    },
    transaction_reason() {
      return this.itemSelected ? this.selectedItem.transaction_reason : ""
    },
    gateway_messages() {
      return this.itemSelected ? this.selectedItem.gateway_messages : ""
    },
    transaction_message() {
      return this.itemSelected ? this.selectedItem.transaction_message : ""
    },
    transaction_amount_raw() {
      return this.itemSelected ? this.selectedItem.transaction_amount_raw : ""
    },
    transaction_currency() {
      return this.itemSelected && this.selectedItem.currency ? this.selectedItem.currency.slug : ""
    },
    transaction_amount() {
      return this.itemSelected ? this.selectedItem.transaction_amount : ""
    },
    transaction_amount_net() {
      return this.itemSelected ? this.selectedItem.transaction_amount_net : ""
    },
    transaction_commission() {
      return this.itemSelected ? this.selectedItem.transaction_commission : ""
    },
    transaction_fees() {
      return this.itemSelected ? this.selectedItem.transaction_fees : ""
    },
    transaction_income() {
      return this.itemSelected ? this.selectedItem.transaction_income : ""
    },
    payer_fees() {
      return this.itemSelected ? this.selectedItem.payer_fees : ""
    },
    payer_commissions() {
      return this.itemSelected ? this.selectedItem.payer_commissions : ""
    },
    extraData() {
      return this.itemSelected ? this.selectedItem.extra_data : []
    },
    transaction_status_state() {
      return !this.submitted || !!this.transaction_status
    },
    can_check_status() {
      return (this.auth.isController() || this.auth.isOpManager() || this.auth.isHelpDesk())
        && this.itemSelected && this.selectedItem.transaction_token
    },
    can_sync_status() {
      return (this.auth.isOpManager() || this.auth.isHelpDesk())
        && this.itemSelected && this.selectedItem.transaction_token
    },
    can_trigger_callback() {
      return this.auth.isOpManager() && this.itemSelected
        && ["SERVICE_TRANSACTION", "USER_SERVICE_TRANSACTION"].includes(this.selectedItem.transaction_type)
        && ["SUCCESS", "CANCELED", "FAILED"].includes(this.selectedItem.transaction_status)
    },
  },
  created() {
    this.fetchingData = true

    Api.get("/transaction/status_filter_list")
      .then(res => this.transaction_status_options = res.data.transaction_states)
      .catch(err => this.error = err)
      .then(() => null)

    Api.get("/operator/list")
      .then(res => this.operators = res.data.operators.map(operator => ({
        text: operator.name,
        value: operator.slug,
      })))
      .catch(err => this.error = err)
      .then(() => null)

    let route = "/transaction/list"

    // check if there are parameters in the URL
    const {
      transaction_ref,
      entity,
      id,
    } = this.$route.query

    if (transaction_ref) {
      route = "/transaction/find_one"
      this.searchData = { transaction_ref }

    } else if (entity && id) {
      route = "/transaction/find"

      if (entity === "USER") {
        this.searchData = { user_id: id }
      } else if (entity === "RAISING") {
        this.searchData = { raising_id: id }
      } else if (entity === "SERVICE") {
        this.searchData = { service_id: id }
      } else if (entity === "BULK") {
        this.searchData = { bulk_payment_id: id }
      }

    } else {
      this.showGroupFilter = true
    }

    Api.get(route, this.searchData)
      .then(res => {
        //checks if transactions were found
        if (res.data.transactions) {
          this.data = res.data.transactions.map(this.mapItem)
          const ref = this.$route.params.ref
          if (ref) {
            this.onItemSelect(this.data.find(it => it.transaction_ref === ref))
          }
        }
      })
      .catch(err => this.error = err)
      .then(() => this.fetchingData = false)
  },
  methods: {
    statusMatch(status1, status2) {
      return status1 === status2 ||
        (status1 === "INITIALIZED" && status2 === "PENDING") ||
        (status2 === "INITIALIZED" && status1 === "PENDING")
    },
    mapItem(item) {
      return {
        ...item,
        logo: item.operator ? asset(item.operator.logo) : null,
        transaction_ref_pretty: truncate(item.transaction_ref, 20),
        transaction_phone_number_pretty: formatAmount(item.transaction_phone_number || ""),
        // transaction_amount_pretty: formatAmount(item.transaction_amount_raw || item.transaction_amount) + this.getCurrencySuffix(item),
        transaction_amount_pretty: formatAmount(item.transaction_amount),
        transaction_fees_pretty: formatAmount(item.transaction_fees),
        transaction_commission_pretty: formatAmount(item.transaction_commission),
        transaction_income_pretty: formatAmount(item.transaction_income),
        status: item.transaction_status_fr,
        statusVariant: item.badge,
        created_at_pretty: item.created_at.replace(" ", "\n"),
        //to resolved ettor when making a search
        operator_transaction_ref: item.operator_transaction_ref ? item.operator_transaction_ref : "",
        transaction_phone_number: item.transaction_phone_number ? item.transaction_phone_number : "",
      }
    },
    getCurrencySuffix(transaction) {
      return transaction.currency && transaction.currency.slug === "EUR" ? " €" : ""
    },
    onItemSelect(item) {
      this.selectedItem = item
      this.modalVisible = true
    },
    clearFields() {
      this.transaction_status = null
      this.update_balance = true
    },
    onModalClose() {
      this.modalVisible = false
      this.submitted = false
      this.selectedItem = null
      this.modalVisible = false
      this.clearFields()
    },
    isFormValid() {
      return !!this.transaction_status
    },
    onFormSubmit() {
      this.submitted = true
      if (!this.isFormValid()) return

      const ans = prompt(`Veuillez saisir "${this.transaction_status}" pour changer le statut de la transaction "${this.selectedItem.operation_type} de ${this.selectedItem.transaction_amount} XAF".`)
      if (ans !== this.transaction_status) return

      this.fetchingFormSubmit = true
      Api.postFormData("/transaction/change_status", {
        transaction_id: this.selectedItem.id,
        transaction_status: this.transaction_status,
        update_balance: this.update_balance,
      })
        .then(res => {
          const transaction = this.mapItem(res.data.transaction)
          this.data = this.data.replaceOne(item => item.id === this.selectedItem.id, transaction)

          this.onModalClose()

          Toast.success(`Le statut de la transaction "${transaction.operation_type} de ${transaction.transaction_amount} XAF" a été mis à jour avec succès !`)
        })
        .catch(err => this.error = err)
        .then(() => this.fetchingFormSubmit = false, this.submitted = false)
    },
    onSearchSubmit() {
      this.data = []
      this.fetchingSearch = true
      Api.get("/transaction/find", {
        search: this.search,
        group: this.transactionGroup,
        start_date: this.startDate,
        end_date: this.endDate,
        status: this.searchStatus,
        operator: this.operator,
        ...this.searchData,
      })
        .then((res) => {
          //checks if transactions were found
          if (res.data.transactions) {
            this.data = res.data.transactions.map(this.mapItem)
          }
        })
        .catch(err => this.error = err)
        .then(() => this.fetchingSearch = false)
    },
    onCheckStatus() {
      this.fetchingCheckStatus = true
      Api.get("/transaction/check_operator_status", { transaction_id: this.selectedItem.id })
        .then(res => alert(JSON.stringify(res.data, null, 4)))
        .catch(err => this.error = err)
        .then(() => this.fetchingCheckStatus = false)
    },
    onSyncStatus() {
      const text = prompt(`Veuillez saisir "SYNC" pour synchroniser le statut de la transaction "${this.selectedItem.operation_type} de ${formatAmount(this.selectedItem.transaction_amount)} XAF".`)
      if (text !== "SYNC") return

      this.fetchingSyncStatus = true
      Api.postFormData("/transaction/sync_transaction_status", {
        transaction_id: this.selectedItem.id,
      })
        .then(res => {
          const transaction = this.mapItem(res.data.transaction)
          this.data = this.data.replaceOne(item => item.id === this.selectedItem.id, transaction)

          this.onModalClose()

          Toast.success(`Le statut de la transaction "${transaction.operation_type} de ${formatAmount(transaction.transaction_amount)} XAF" a été mis à jour avec succès !`)
        })
        .catch(err => this.error = err)
        .then(() => this.fetchingSyncStatus = false)
    },
    onTriggerCallback() {
      const service = this.selectedItem.extra_data.find(el => el.key === "Service").value
      const text = prompt(`Veuillez saisir "CALLBACK" pour notifier le service ${service} de la transaction "${this.selectedItem.operation_type} de ${formatAmount(this.selectedItem.transaction_amount)} XAF".`)
      if (text !== "CALLBACK") return

      this.fetchingTriggerCallback = true
      Api.postFormData("/transaction/notify_service", {
        transaction_id: this.selectedItem.id,
      })
        .then(res => {
          const transaction = this.mapItem(res.data.transaction)
          this.data = this.data.replaceOne(item => item.id === this.selectedItem.id, transaction)

          this.onModalClose()

          Toast.success(`Le service ${service} a été notifié, veuillez consulter les logs.`)
        })
        .catch(err => this.error = err)
        .then(() => this.fetchingTriggerCallback = false)
    },
  },
}
</script>

<style scoped>
.logo {
  max-height: 24px;
  border-radius: 0;
}
</style>
